import { SxProps, Theme } from '@rossum/ui/material';

export const queueSettingsRowSx: SxProps<Theme> = {
  mb: '20px',
  alignItems: 'center',
  justifyContent: 'space-between',
  '& > div:first-child': {
    width: 264,
    fontSize: '15px',
  },
  '& > div:nth-child(2)': {
    width: 336,
  },
};
